import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import { createGraphQLRequest } from "../../../../api/utils/httpRequest"
import type {
    ResponseData,
    SchematizedData,
    SchematizedLayoutDeleteData,
    SchematizedSaveData,
} from "../../../../graphql/types"

export const fetchSchematizedData = (
    headers: Record<string, any>,
    locationId: Maybe<string>
): Promise<Maybe<SchematizedData[]>> =>
    createGraphQLRequest({
        headers: headers,
        body: {
            query: `
                query schematizedV2($locationId: String!) {
                    schematizedV2(locationId: $locationId) {
                        layoutId
                        name   
                        sortIndex                   
                        size
                        data {
                            id
                            isRoot
                            pages {
                                id
                                tiles {
                                    id
                                    type
                                    x
                                    y
                                    isSticky
                                    targetPageGroupId
                                    categoryId                               
                                    customFolder {
                                        name
                                        color
                                        icon
                                    }
                                }                           
                            }
                        }
                    }
                }
            `,
            operationName: "schematizedV2",
            variables: {
                locationId: locationId,
            },
        },
    }).then(response => {
        if (response && response.data && response.data.schematizedV2) {
            return response.data.schematizedV2
        }

        return null
    })

export const schematizedSaveApi = (
    headers: Record<string, any>,
    data: SchematizedSaveData
): Promise<Maybe<ResponseData>> =>
    createGraphQLRequest({
        headers: headers,
        body: {
            query: `
                 mutation schematizedSave($data: SchematizedSaveData!) {
                    schematizedSave(data: $data) {
                      success
                    }
                }
            `,
            operationName: "schematizedSave",
            variables: {
                data: data,
            },
        },
    }).then(response => {
        return response.schematizedSave
    })

export const schematizedLayoutDeleteApi = (
    headers: Record<string, any>,
    data: SchematizedLayoutDeleteData
): Promise<Maybe<ResponseData>> =>
    createGraphQLRequest({
        headers: headers,
        body: {
            query: `
                 mutation schematizedLayoutDelete($data: SchematizedLayoutDeleteData!) {
                    schematizedLayoutDelete(data: $data) {
                      success
                    }
                }
            `,
            operationName: "schematizedLayoutDelete",
            variables: {
                data: data,
            },
        },
    }).then(response => {
        return response.schematizedSave
    })
